import { render, staticRenderFns } from "./NftStatisticPatients.vue?vue&type=template&id=5bd64e74&scoped=true&"
import script from "./NftStatisticPatients.vue?vue&type=script&lang=js&"
export * from "./NftStatisticPatients.vue?vue&type=script&lang=js&"
import style0 from "./NftStatisticPatients.vue?vue&type=style&index=0&id=5bd64e74&prod&lang=scss&scoped=true&"
import style1 from "./NftStatisticPatients.vue?vue&type=style&index=1&id=5bd64e74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd64e74",
  null
  
)

export default component.exports